export function toAnalyticsBrokerId(value) {
    if (value == null || value === '') {
        return null
    }

    const parsed = Number(value)

    return Number.isFinite(parsed) ? parsed : null
}

export function getActingBrokerId() {
    const { getAuthStore } = require('stores/AuthStore')
    const id = getAuthStore()?.loggedInBrokerId

    return toAnalyticsBrokerId(id)
}

/**
 * Añade actingBrokerId (sesión) y brokerId (dueño del cliente si viene; si no, actingBrokerId).
 * No reemplaza un brokerId explícito del dueño cuando es un número finito.
 */
export function enrichWithBrokerParams(params = {}) {
    const sessionActingBrokerId = getActingBrokerId()
    const actingBrokerId =
        toAnalyticsBrokerId(params.actingBrokerId) ?? sessionActingBrokerId

    const ownerBrokerId = toAnalyticsBrokerId(params.brokerId)
    const brokerId = ownerBrokerId ?? actingBrokerId

    return {
        ...params,
        actingBrokerId,
        brokerId,
    }
}
